// Acesso unificado as variaveis de ambiente Vite (`import.meta.env.*`).
// Arquivos da app NAO leem `import.meta.env` direto — sempre via ENV. Isso
// concentra validacao (presenca de obrigatorias) e default-values em um
// unico ponto, e mantem fronteira clara entre runtime e config.
//
// **Importante:** acessamos `import.meta.env.VITE_*` diretamente (nao via
// objeto intermediario `const env = import.meta.env`) porque o `vite.config.ts`
// usa `define` para substituir `import.meta.env.VITE_API_URL` em modo E2E
// (bypassa MSYS2 path translation no Windows). `define` so substitui
// expressao TEXTUAL exata — `env.VITE_API_URL` nao e capturado.

function required(key: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(`Missing env: ${key}. Verifique .env.local ou .env.example.`);
  }
  return value;
}

export const ENV = {
  API_URL: required('VITE_API_URL', import.meta.env.VITE_API_URL),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? '',
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE ?? '',
  ENABLE_DEVTOOLS: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
  // Apple App ID (numerico) — opcional ate o app ser publicado na App Store.
  // Quando ausente, os botoes "Baixar pra iPhone" caem em busca por nome.
  APPLE_APP_ID: import.meta.env.VITE_APPLE_APP_ID ?? '',
  // Client IDs de OAuth social (login). Opcionais — quando ausentes, os botoes
  // "continue com" nem aparecem na tela de login (paridade com o app mobile).
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID ?? '',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  IS_TEST: import.meta.env.MODE === 'test',
} as const;
